import {
  SET_VOUCHER_COOKIES,
  SET_MEMBER_COOKIES,
  SET_TICKET_COOKIES,
  SET_LISTING_COOKIES,
  SET_MEMBER_PROFILE_COOKIES,
  SET_NOTIFICATION_COOKIES,
  SET_GIF_CERTIFICATE_COOKIES,
  SET_OTHERLOCATIONS_COOKIES,
  SET_GAME_COOKIES,
  SET_POS_PROMO_COOKIES,
} from '../actions/cookies'

const initialState = {
  voucherCookies: {},
  memberCookies: {},
  ticketCookies: {},
  listingCookies: {},
  memberProfileCookies: {},
  notificationCookies: {},
  gameCookies: {},
  otherLocationsCookies: {},
  posPromoCookies: {},
}

export default function cookies(state = initialState, action) {
  switch (action.type) {
    case SET_VOUCHER_COOKIES:
      return {
        ...state,
        voucherCookies: action.voucherCookies,
      }
    case SET_GIF_CERTIFICATE_COOKIES:
      return {
        ...state,
        gifCertificateCookies: action.payload,
      }
    case SET_MEMBER_COOKIES:
      return {
        ...state,
        memberCookies: action.memberCookies,
      }
    case SET_TICKET_COOKIES:
      return {
        ...state,
        ticketCookies: action.ticketCookies,
      }
    case SET_LISTING_COOKIES:
      return {
        ...state,
        listingCookies: action.listingCookies,
      }
    case SET_MEMBER_PROFILE_COOKIES:
      return {
        ...state,
        memberProfileCookies: action.memberProfileCookies,
      }
    case SET_NOTIFICATION_COOKIES:
      return {
        ...state,
        notificationCookies: action.notificationCookies,
      }
    case SET_OTHERLOCATIONS_COOKIES:
      return {
        ...state,
        otherLocationsCookies: action.otherLocationsCookies,
      }
    case SET_GAME_COOKIES:
      return {
        ...state,
        gameCookies: action.payload,
      }
    case SET_POS_PROMO_COOKIES:
      return {
        ...state,
        posPromoCookies: action.payload,
      }
    default:
      return state
  }
}
